import { useClose } from "@headlessui/react";
import { zodResolver } from "@hookform/resolvers/zod";
import { useDebouncedEffect } from "@react-hookz/web";
import { useMemo } from "react";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { TextInput, Typography } from "@/components/atoms";
import { FilterDrawer } from "../common/FilterDrawer";
import { FilterPopover } from "../common/FilterPopover";
import { useVehicleFilters } from "../useVehicleFilters";

const schema = z.object({
  make: z.string(),
});

type FormData = z.infer<typeof schema>;

export const MakeFilter = () => {
  const {
    filters: { make },
    setFilter,
  } = useVehicleFilters();

  const value = useMemo(() => make, [make]);

  const onClose = () => setFilter("make", undefined);

  return (
    <FilterPopover name="make" value={value} label="Make" onClose={onClose}>
      <MakeFilterForm />
    </FilterPopover>
  );
};

interface MakeFilterDrawerProps {
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}

export const MakeFilterDrawer = ({ open, onOpenChange }: MakeFilterDrawerProps) => {
  const {
    filters: { make },
    setFilter,
  } = useVehicleFilters();

  const value = useMemo(() => make, [make]);

  const onClose = () => setFilter("make", undefined);

  return (
    <FilterDrawer open={open} onOpenChange={onOpenChange} value={value} label="Make" onClose={onClose}>
      <MakeFilterForm />
    </FilterDrawer>
  );
};

const MakeFilterForm = () => {
  const close = useClose();
  const { setFilter, filters } = useVehicleFilters();

  const { watch, register } = useForm<FormData>({
    resolver: zodResolver(schema),
    defaultValues: { make: filters.make ? filters.make : "" },
  });

  const value = watch("make");

  useDebouncedEffect(
    () => {
      setFilter("make", value);
    },
    [value],
    300
  );

  return (
    <form
      className="contents"
      onSubmit={(event) => {
        event.preventDefault();
        close();
      }}
    >
      <Typography className="mb-4">Search Make</Typography>
      <TextInput {...register("make")} size="md" iconName="SearchNormal1" placeholder="Search Make" />
    </form>
  );
};
